import React, { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { CContainer, CSpinner } from '@coreui/react'

// routes config
import routes from '../routes'

const loading = (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
    }}
  >
    <CSpinner color="primary" size="sm" style={{ width: '3rem', height: '3rem' }} />
  </div>
)
const AppContent = () => {
  const restrictedRoles = ['technical-support', 'house-lead']
  const currentUser = JSON.parse(localStorage.getItem('user') || '{}')
  const currentRole = currentUser?.role || ''
  const isRestrictedRole = restrictedRoles.includes(currentRole)
  const allowedRoutes = isRestrictedRole
    ? routes.filter((route) => route.path === '/messages')
    : routes

  return (
    <CContainer lg>
      <Suspense fallback={loading}>
        <Routes>
          {allowedRoutes.map((route, idx) => {
            return (
              route.element && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  element={<route.element />}
                />
              )
            )
          })}
          <Route path="/" element={<Navigate to={isRestrictedRole ? 'messages' : 'dashboard'} replace />} />
          {isRestrictedRole && <Route path="*" element={<Navigate to="/messages" replace />} />}
        </Routes>
      </Suspense>
    </CContainer>
  )
}

export default React.memo(AppContent)
